(function () {
  'use strict';

  document.querySelectorAll('[data-faq-root]').forEach(function (root) {
    var buttons = root.querySelectorAll('.faq-q');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        var answer = item.querySelector('.faq-a');
        var inner = item.querySelector('.faq-a__inner');
        var isOpen = item.classList.contains('is-open');

        root.querySelectorAll('.faq-item.is-open').forEach(function (open) {
          open.classList.remove('is-open');
          open.querySelector('.faq-a').style.height = '0';
          open.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          answer.style.height = inner.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    window.addEventListener('resize', function () {
      root.querySelectorAll('.faq-item.is-open').forEach(function (open) {
        open.querySelector('.faq-a').style.height = open.querySelector('.faq-a__inner').scrollHeight + 'px';
      });
    });
  });
})();
